import { Injectable } from '@angular/core';
import { LoadFontListQuery } from '@queries/generated';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppLayoutService {
  sidebarEnabled$ = new BehaviorSubject(true);
  topbarEnabled$ = new BehaviorSubject(true);
  optOutEnabled$ = new BehaviorSubject(true);
  optOutExplicitlyDisabled = false;
  notificationsEnabled$ = new BehaviorSubject(true);
  noScroll$ = new BehaviorSubject(false);
  fonts$ = this.loadFontListQuery.watch().valueChanges.pipe(map(({ data }) => data.fonts));

  constructor(private loadFontListQuery: LoadFontListQuery) {}

  disableSidebar() {
    this.sidebarEnabled$.next(false);
  }

  disableTopbar() {
    this.topbarEnabled$.next(false);
  }

  disableOptOut() {
    this.optOutExplicitlyDisabled = true;
    this.optOutEnabled$.next(false);
  }

  enableOptOut() {
    if (!this.optOutExplicitlyDisabled) {
      this.optOutEnabled$.next(true);
    }
  }

  disableNotifications() {
    this.notificationsEnabled$.next(false);
  }

  disableAll() {
    this.disableSidebar();
    this.disableTopbar();
    this.disableOptOut();
    this.disableNotifications();
  }

  noScroll() {
    this.noScroll$.next(true);
  }
}
